// extracted by mini-css-extract-plugin
export var Text = "j_Z";
export var typeBody = "j_0";
export var typeCaption = "j_3";
export var typeHeading = "j_1";
export var typeSubheading = "j_2";